import React, { useRef, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useMutation, gql } from '@apollo/client'
import { validateFunc } from '../../../constraints/constraints'
import useStyles from '../styles'
import useGlobalStyles from '../../../utils/globalStyles'
import { Box, Typography, Input, Button } from '@mui/material'
import { saveAppsFlyerKeyConfiguration } from '../../../apollo'

const SAVE_APPSFLYER_CONFIGURATION = gql`
  ${saveAppsFlyerKeyConfiguration}
`

function AppsFlyerConfiguration(props) {
  const formRef = useRef()
  const [appsFlyerAppId] = useState(props.appsFlyerAppId || '')
  const [appsFlyerDevKey] = useState(props.appsFlyerDevKey || '')

  const [appsFlyerAppIdError, setAppsFlyerAppIdError] = useState(null)
  const [appsFlyerDevKeyError, setAppsFlyerDevKeyError] = useState(null)

  const [mutate, { loading }] = useMutation(SAVE_APPSFLYER_CONFIGURATION)

  const onBlur = (setter, field, state) => {
    setter(!validateFunc({ [field]: state }, field))
  }

  const validateInput = () => {
    let appsFlyerAppIdResult = true
    let appsFlyerDevKeyResult = true

    appsFlyerAppIdResult = !validateFunc(
      { appsFlyerAppId: formRef.current['input-appsFlyerAppId'].value },
      'appsFlyerAppId'
    )
    appsFlyerDevKeyResult = !validateFunc(
      { appsFlyerDevKey: formRef.current['input-appsFlyerDevKey'].value },
      'appsFlyerDevKey'
    )

    setAppsFlyerAppIdError(appsFlyerAppIdResult)
    setAppsFlyerDevKeyError(appsFlyerDevKeyResult)

    return appsFlyerAppIdResult && appsFlyerDevKeyResult
  }

  const classes = useStyles()
  const globalClasses = useGlobalStyles()

  return (
    <Box container className={classes.container}>
      <Box className={classes.flexRow}>
        <Box item className={classes.heading}>
          <Typography variant="h6" className={classes.text}>
            AppsFlyer Configuration
          </Typography>
        </Box>
      </Box>

      <Box className={classes.form}>
        <form ref={formRef}>
          <Box>
            <Typography className={classes.labelText}>
              AppsFlyer App ID
            </Typography>
            <Input
              style={{ marginTop: -1 }}
              id="input-appsFlyerAppId"
              name="input-appsFlyerAppId"
              placeholder="Enter AppsFlyer App ID"
              type="text"
              defaultValue={appsFlyerAppId}
              onBlur={event =>
                onBlur(
                  setAppsFlyerAppIdError,
                  'appsFlyerAppId',
                  event.target.value
                )
              }
              disableUnderline
              className={[
                globalClasses.input,
                appsFlyerAppIdError === false
                  ? globalClasses.inputError
                  : appsFlyerAppIdError === true
                  ? globalClasses.inputSuccess
                  : ''
              ]}
            />
          </Box>
          <Box>
            <Typography className={classes.labelText}>
              AppsFlyer Dev Key
            </Typography>
            <Input
              style={{ marginTop: -1 }}
              id="input-appsFlyerDevKey"
              name="input-appsFlyerDevKey"
              placeholder="Enter AppsFlyer Dev Key"
              type="password"
              defaultValue={appsFlyerDevKey}
              onBlur={event =>
                onBlur(
                  setAppsFlyerDevKeyError,
                  'appsFlyerDevKey',
                  event.target.value
                )
              }
              disableUnderline
              className={[
                globalClasses.input,
                appsFlyerDevKeyError === false
                  ? globalClasses.inputError
                  : appsFlyerDevKeyError === true
                  ? globalClasses.inputSuccess
                  : ''
              ]}
            />
          </Box>
          <Box>
            <Button
              className={globalClasses.button}
              disabled={loading}
              onClick={e => {
                e.preventDefault()
                if (validateInput() && !loading) {
                  mutate({
                    variables: {
                      configurationInput: {
                        appsFlyerAppId:
                          formRef.current['input-appsFlyerAppId'].value,
                        appsFlyerDevKey:
                          formRef.current['input-appsFlyerDevKey'].value
                      }
                    }
                  })
                }
              }}>
              SAVE
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  )
}

export default withTranslation()(AppsFlyerConfiguration) 